import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

/**
 * API service for CPO transactions management
 */
const cpoTransactionApi = {
  /**
   * Fetch the CPO transactions list with pagination
   * @param {QueryParameters} query - The query parameters
   * @returns {Promise<any>} A promise that resolves with the transactions list
   */
  fetchCpoTransactions: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list`, {
      ...parameters,
    });
  },

  /**
   * Fetch the filters for CPO transactions list
   * @returns {Promise<any>} A promise that resolves with the list filters
   */
  fetchCpoTransactionFilters: (): Promise<any> => {
    return getRequest(`${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list/filter-list`);
  },

  /**
   * Export CPO transactions data
   * @param {QueryParameters} query - The query parameters
   * @returns {Promise<any>} A promise that resolves with the export data
   */
  fetchCpoTransactionsExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list/export`, {
      ...parameters,
    });
  },

  /**
   * Fetch CPO transaction by ID
   * @param {string} id - The transaction ID
   * @returns {Promise<any>} A promise that resolves with the transaction info
   */
  fetchCpoTransactionById: (id: string): Promise<any> => {
    return getRequest(`${config.cpo.transactionApiUrl}api/common/v1/charging-transaction/transaction-list/${id}`);
  },
};

export default cpoTransactionApi;
